import { Pipe, PipeTransform, inject } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'convertTimestamp',
  standalone: false,
})
export class ConvertTimestampPipe implements PipeTransform {
  private datePipe = inject(DatePipe);

  transform(value: number, format: string = 'medium'): string {
    const date = new Date(value * 1000); // Convert seconds to milliseconds
    return this.datePipe.transform(date, format) || ''; // Format the date using the specified format
  }
}
